const typeProductCard = () => {
	const typeBlock = document.querySelector('[data-btn="type-card"]'), 
		  productsHorizontalList = document.querySelector('.horizontal-card');

	// переключение типа карточки
	try {
		typeBlock.addEventListener('click', ()=>{
			let horizontal 	= typeBlock.querySelector('.horizontal-product'),
				vertical	= typeBlock.querySelector('.vertical-product'),
				catalogList = typeBlock.closest('.catalog-list-wrap').querySelector('.catalog-list');

			if(horizontal.classList.contains('active')) {
				horizontal.classList.remove('active');
				vertical.classList.add('active');
				catalogList.classList.remove('horizontal-card');

				// вертикальная карточка
				fetch('/local/templates/schmetz/ajax/changeViewMode.php?mode=vertical')
					.then((data) => {
						return function (data) {};
					});
			} else {
				horizontal.classList.add('active');
				vertical.classList.remove('active');
				catalogList.classList.add('horizontal-card');

				// горизонтальная карточка
				fetch('/local/templates/schmetz/ajax/changeViewMode.php?mode=horizontal')
					.then((data) => {
						return function (data) {};
						
					});
			}
		});
	} catch(e) {}

	// ресайз
	try {
		if(typeBlock || productsHorizontalList) {
			let horizontal 	= typeBlock.querySelector('.horizontal-product'),
				vertical	= typeBlock.querySelector('.vertical-product'),
				catalogList = typeBlock.closest('.catalog-list-wrap').querySelector('.catalog-list');

			addEventListener('resize',()=>{
				if(window.innerWidth < 610) {
					horizontal.classList.remove('active');
					vertical.classList.add('active');
					catalogList.classList.remove('horizontal-card');
				}
			});
		}
	} catch(e){}
};

export default typeProductCard;